import { z } from 'zod';
import email from '../common/email.dto';
import reference from '../common/reference.dto';
import id from '../common/uuid.dto';

const status = z
  .enum(['I’m Ok', 'Emergency', 'Traveling', 'Home', 'Unknown'])
  .array();

const vip = z.enum(['person', 'group']);

const positionType = z.enum([
  'Exact',
  'City',
  'Region',
  'Region',
  'Travel booking',
]);

// This is not used yet but should be used later for details of the user
const person = z.object({
  id,
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  organization: reference,
  email: email.nullable().optional(),
  positionType,
  lastLocationTime: z.coerce.date(),
  emergency: reference.optional(),
  hasApp: z.boolean(),
  status,
  vip: vip.optional(),
});

// For now this is used for all persons in lists
export const personCard = person.pick({
  id: true,
  firstName: true,
  lastName: true,
  email: true,
  organization: true,
  vip: true,
  hasApp: true,
  emergency: true,
  lastLocationTime: true,
  positionType: true,
  status: true,
});

export const personCardOrReference = personCard.or(reference);

export default person;

export type Person = z.infer<typeof person>;
export type PersonCard = z.infer<typeof personCard>;
export type PersonCardOrReference = z.infer<typeof personCardOrReference>;
export type Status = z.infer<typeof status>;
